module.exports = __webpack_public_path__ + "img/sub-failed.c70a0858.png";